var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"clear-filters",on:{"click":function($event){return _vm.$emit('clear')}}},[_c('i',{staticClass:"fas fa-trash"}),_vm._v(" "+_vm._s(_vm.$t('clearFilters'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }